/* global modForm */
/**
 * Prevent default if form is loading or swiper is animating
 * @param {Event} e - The event object to handle
 */
export function preventSkip(e) {
	if (modForm.opts.isFormLoading || (modForm.opts.formSwiperInstance && modForm.opts.formSwiperInstance.animating)) {
		e.preventDefault();
	}
}
